export default function GeneralEditor() {
    return (
        <div>
            <h1>General Editor</h1>
        </div>
    );
}